import { useState, useEffect } from "react";
import { apiUrl } from "utils/api";

const useProductDetailsData = (id) => {
  const [detailsData, setDetailsData] = useState(null);
  const [loadingDetails, setLoading] = useState(true);
  const [errorFooter, setError] = useState(null);

  useEffect(() => {
    const fetchDetailsData = async () => {
      try {
        const response = await fetch(apiUrl(`details/${id}`));
        //     const response = await fetch(`/api/details/${id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setDetailsData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchDetailsData();
    }
  }, [id]);

  return { detailsData, loadingDetails, errorFooter };
};

export default useProductDetailsData;
